import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { filter } from 'rxjs/operators';

// declare GTM dataLayer
declare global {
  interface Window {
    dataLayer?: any[];
  }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) pid: object, router: Router, private title: Title) {
    this.isBrowser = isPlatformBrowser(pid);
    if (!this.isBrowser) return;

    window.dataLayer = window.dataLayer || [];

    router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        const page_location = location.href;
        const page_title = this.title.getTitle();
        const page_path = e.urlAfterRedirects || e.url;
        this.trackPageView(page_location, page_title, page_path);
      });
  }

  trackPageView(page_location: string, page_title?: string, page_path?: string) {
    const app_platform = Capacitor.getPlatform(); // 'web' | 'ios' | 'android'

    window.dataLayer!.push({
      event: 'page_view',
      page_location,
      page_title,
      page_path,
      app_platform,
    });
  }

  trackEvent(name: string, params: Record<string, any> = {}) {
    const app_platform = Capacitor.getPlatform();

    window.dataLayer!.push({ event: name, ...params, app_platform });
  }
}
